export default "__VITE_ASSET__UNWigYn8__"